// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608170504/js/" + chunkId + "." + {"44":"886ebba0","225":"1678dcc4","481":"3a053a43","486":"c0facd4a","770":"bcd7e6d7"}[chunkId] + ".0.28445616417816555.chunk.js";
};